
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/board-results/uttar-pradesh-board-10th-result",
      function () {
        return require("private-next-pages/education/board-results/uttar-pradesh-board-10th-result.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/board-results/uttar-pradesh-board-10th-result"])
      });
    }
  